import React from 'react'
import headerPic from '../../Images/female/Group 8425.png'

const Header = () => {
  return (
    <header className='px-10 pb-2'>
        <section className='lg:flex justify-center items-center'>
            {/* tittle section */}
            <div className=''>
                <h1 className='text-[#575757] font-bold text-6xl'>
                <span className='text-orange-400'>Skip</span> The Diet,<br />
                Just Eat Healthy <br />
                With Food Network
                </h1><br />

                <p className='text-[#828282] text-xl font-medium'>
                Imagine you don't need a diet because we provide <br />
                healthy and delicious food for you!
                </p><br />

                <button className='bg-gradient-to-r from-orange-400 to-red-500 py-2 px-4 rounded-full text-white text-medium'>Food Order</button>
            </div>

            {/* image section */}
            <div className='w-[500px]'>
                <img className='' src={headerPic} alt="" />
            </div>
        </section>
    </header>
  )
}

export default Header